
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { InnerMenuSalesComponent } from './inner-menu-sales.component';
import { SalesIndividualComponent } from './components/sales-individual/sales-individual.component';
import { SalesCorporateComponent } from './components/sales-corporate/sales-corporate.component';
import { RedirectComponent } from '../shared/components/redirect/redirect.component';
import { AuthGuard } from '../shared/auth.guard';


export const InnerMenuSalesRoutes: Routes = [
    {
        path: '',
        component: InnerMenuSalesComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                component: RedirectComponent,
            },
            {
                path: 'individual',
                component: SalesIndividualComponent,
            },
            {
                path: 'corporate',
                component: SalesCorporateComponent,
            },
        ]
    },
];

@NgModule({
    imports: [RouterModule.forChild(InnerMenuSalesRoutes)],
    exports: [RouterModule],
    providers: []
})
export class InnerMenuSalesRoutingModule { }
